module.exports = __webpack_public_path__ + "img/Portrait_Placeholder.4788048f.png";